exports.Routes = {
  ApiSpecPage: (query) => ({ pathname: "/internal/api-spec", query }),
  CegatEventsPage: (query) => ({ pathname: "/internal/cegat-events", query }),
  AllEventsPage: (query) => ({ pathname: "/internal/events", query }),
  FinancePage: (query) => ({ pathname: "/internal/finance", query }),
  AdminSummaryPage: (query) => ({ pathname: "/internal/subjects/[subjectId]", query }),
  SubjectModificationPage: (query) => ({ pathname: "/internal/subjects/[subjectId]/modify", query }),
  SubjectTransferPage: (query) => ({ pathname: "/internal/subjects/[subjectId]/transfer", query }),
  SubjectsAdminPage: (query) => ({ pathname: "/internal/subjects", query }),
  UserModificationsPage: (query) => ({ pathname: "/internal/user-modifications", query }),
  AdminUserDetailsPage: (query) => ({ pathname: "/internal/users/[userId]", query }),
  UsersAdminPage: (query) => ({ pathname: "/internal/users", query }),
  SignupPageDistributors: (query) => ({ pathname: "/distributors", query }),
  ForgotPasswordPage: (query) => ({ pathname: "/forgot-password", query }),
  LoginPage: (query) => ({ pathname: "/login", query }),
  ResendVerificationPage: (query) => ({ pathname: "/resend-verification", query }),
  ResetPasswordPage: (query) => ({ pathname: "/reset-password", query }),
  SignupPage: (query) => ({ pathname: "/signup", query }),
  VerifyEmailPage: (query) => ({ pathname: "/verify-email", query }),
  Page404: (query) => ({ pathname: "/404", query }),
  Dashboard: (query) => ({ pathname: "/", query }),
  AssignedSamplesPage: (query) => ({ pathname: "/samples/assigned", query }),
  SampleRegistrationPage: (query) => ({ pathname: "/samples", query }),
  AccountPage: (query) => ({ pathname: "/account", query }),
  OneDoctorPage: (query) => ({ pathname: "/doctor-management/[doctorId]", query }),
  DoctorsPage: (query) => ({ pathname: "/doctor-management", query }),
  SubjectClinicalInfo: (query) => ({ pathname: "/subjects/[subjectId]/clinical-info", query }),
  SubjectDNATest: (query) => ({ pathname: "/subjects/[subjectId]/dna-test", query }),
  SubjectFamilyHistory: (query) => ({ pathname: "/subjects/[subjectId]/family-history", query }),
  SubjectPersonalInfo: (query) => ({ pathname: "/subjects/[subjectId]/personal-info", query }),
  SubjectSummary: (query) => ({ pathname: "/subjects/[subjectId]/summary", query }),
  AddSamplePage: (query) => ({ pathname: "/subjects2/[subjectId]/[individualId]/add-sample", query }),
  AddFamilyMemberPage: (query) => ({ pathname: "/subjects2/[subjectId]/add-family-member", query }),
  Subject2: (query) => ({ pathname: "/subjects2/[subjectId]", query })
}